var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"news-page inner-body-block"},[_c('h1',[_vm._v(_vm._s(_vm.meta.h1))]),_vm._v(" "),_c('div',{directives:[{name:"interpolation",rawName:"v-interpolation"}],domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }